var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.06,6.58C14,6.58,5.81,14.77,5.81,24.83S14,43.07,24.06,43.07c10.06,0,18.25-8.19,18.25-18.25 S34.12,6.58,24.06,6.58z M24.06,40.02c-8.38,0-15.19-6.81-15.19-15.19S15.68,9.64,24.06,9.64c8.38,0,15.19,6.81,15.19,15.19 S32.43,40.02,24.06,40.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.24,24.83c0-4.49,1.63-8.83,4.59-12.22c0.58-0.66,0.55-1.66-0.08-2.29C8.1,9.67,6.93,9.7,6.33,10.39 c-3.51,4-5.44,9.13-5.44,14.44s1.93,10.44,5.44,14.44c0.31,0.35,0.76,0.56,1.24,0.56c0.45,0,0.87-0.17,1.2-0.51 c0.61-0.61,0.64-1.61,0.07-2.27C5.87,33.66,4.24,29.32,4.24,24.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.78,10.39c-0.6-0.69-1.74-0.74-2.44-0.05c-0.61,0.61-0.64,1.61-0.07,2.27c2.96,3.39,4.59,7.72,4.59,12.22 s-1.63,8.83-4.59,12.22c-0.58,0.66-0.55,1.66,0.08,2.29c0.32,0.32,0.73,0.49,1.18,0.49h0c0.47,0,0.93-0.2,1.24-0.56 c3.51-4,5.44-9.13,5.44-14.44S45.29,14.39,41.78,10.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.23,14.3c1.52-0.26,3.66-0.45,6.66-0.45c3.04,0,5.21,0.58,6.66,1.75c1.39,1.1,2.33,2.91,2.33,5.05 c0,2.14-0.71,3.95-2.01,5.18c-1.68,1.59-4.17,2.3-7.09,2.3c-0.65,0-1.23-0.03-1.68-0.1v7.8h-4.89V14.3z M21.11,24.2 c0.42,0.1,0.94,0.13,1.65,0.13c2.62,0,4.24-1.33,4.24-3.56c0-2.01-1.39-3.2-3.85-3.2c-1,0-1.68,0.1-2.04,0.19V24.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg49);
export default __webpack_public_path__ + "static/media/49.6b2d349044d391198b6686c1b5883340.svg";
export { ForwardRef as ReactComponent };